import React from 'react'
import Loader from '../../components/Loader'

const Error = () => {
  return (
    <div style={{display:'flex',justifyContent:"center",alignItems:'center',minHeight:'100vh'}} >

<Loader />

    </div>
  )
}

export default Error